import { bindActionCreators, Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { InterpalsWebApi } from 'api';
import { ReduxState } from '../root-reducer';
import store from '../redux-store';

import * as actionCreators from './all';

export type Dispatch = ThunkDispatch<ReduxState, InterpalsWebApi, Action>;

const actions: typeof actionCreators = bindActionCreators(actionCreators, store.dispatch);

export default actions;
